// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as QuickRouteImport } from './routes/quick'
import { Route as ProgressRouteImport } from './routes/progress'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as AppRouteImport } from './routes/app'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProtocolsIndexRouteImport } from './routes/protocols.index'
import { Route as ConsoIndexRouteImport } from './routes/conso.index'
import { Route as ProtocolsGoalRouteImport } from './routes/protocols.$goal'
import { Route as DebugThrowRouteImport } from './routes/debug.throw'
import { Route as DebugSentryTestRouteImport } from './routes/debug.sentry-test'
import { Route as AdminPaymentsRouteImport } from './routes/admin.payments'
import { Route as AdminGrantsRouteImport } from './routes/admin.grants'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as ProtocolsGoalCaptureStepKeyRouteImport } from './routes/protocols.$goal_.capture.$stepKey'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const QuickRoute = QuickRouteImport.update({
            id: '/quick',path: '/quick',getParentRoute: () => rootRouteImport
          })
const ProgressRoute = ProgressRouteImport.update({
            id: '/progress',path: '/progress',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const HistoryRoute = HistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const BillingRoute = BillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProtocolsIndexRoute = ProtocolsIndexRouteImport.update({
            id: '/protocols/',path: '/protocols/',getParentRoute: () => rootRouteImport
          })
const ConsoIndexRoute = ConsoIndexRouteImport.update({
            id: '/conso/',path: '/conso/',getParentRoute: () => rootRouteImport
          })
const ProtocolsGoalRoute = ProtocolsGoalRouteImport.update({
            id: '/protocols/$goal',path: '/protocols/$goal',getParentRoute: () => rootRouteImport
          })
const DebugThrowRoute = DebugThrowRouteImport.update({
            id: '/debug/throw',path: '/debug/throw',getParentRoute: () => rootRouteImport
          })
const DebugSentryTestRoute = DebugSentryTestRouteImport.update({
            id: '/debug/sentry-test',path: '/debug/sentry-test',getParentRoute: () => rootRouteImport
          })
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
            id: '/admin/payments',path: '/admin/payments',getParentRoute: () => rootRouteImport
          })
const AdminGrantsRoute = AdminGrantsRouteImport.update({
            id: '/admin/grants',path: '/admin/grants',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/return',path: '/return',getParentRoute: () => CheckoutRoute
          })
const ProtocolsGoalCaptureStepKeyRoute = ProtocolsGoalCaptureStepKeyRouteImport.update({
            id: '/protocols/$goal_/capture/$stepKey',path: '/protocols/$goal/capture/$stepKey',getParentRoute: () => rootRouteImport
          })





const CheckoutRouteChildren = {
  CheckoutReturnRoute: CheckoutReturnRoute
}

const CheckoutRouteWithChildren = CheckoutRoute._addFileChildren(CheckoutRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccountRoute: AccountRoute,AppRoute: AppRoute,BillingRoute: BillingRoute,CheckoutRoute: CheckoutRouteWithChildren,FaqRoute: FaqRoute,ForgotPasswordRoute: ForgotPasswordRoute,HistoryRoute: HistoryRoute,LoginRoute: LoginRoute,ProgressRoute: ProgressRoute,QuickRoute: QuickRoute,ResetPasswordRoute: ResetPasswordRoute,SettingsRoute: SettingsRoute,UnsubscribeRoute: UnsubscribeRoute,AdminGrantsRoute: AdminGrantsRoute,AdminPaymentsRoute: AdminPaymentsRoute,DebugSentryTestRoute: DebugSentryTestRoute,DebugThrowRoute: DebugThrowRoute,ProtocolsGoalRoute: ProtocolsGoalRoute,ConsoIndexRoute: ConsoIndexRoute,ProtocolsIndexRoute: ProtocolsIndexRoute,ProtocolsGoalCaptureStepKeyRoute: ProtocolsGoalCaptureStepKeyRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)